// extracted by mini-css-extract-plugin
module.exports = {"root":"card_root__2Fn_e","head":"card_head__2eTff"};